import { useEffect } from "react";
import { useAuth } from "src/hook/useContext";

const Logout = () => {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  },[]);

  return <></>;
};

export default Logout;
